import React, { useEffect, useState } from 'react'
import { Accordion, AccordionTab } from 'primereact/accordion'
import { useTranslation } from 'react-i18next'
import moment from 'moment'

// local imports
import './SquadsEventsSideBar.scss'
import AsyncImage from 'components/ui/AsyncImage'
import { ICalendarPlan, ISideBarModel } from 'types/CalendarType'
import { IEmployeeSummary } from 'types/Employee'
import { PlanTypes } from 'types/BaseType'
import location from 'assets/icons/location-marker-gray.svg'
import building from 'assets/icons/bina-gray.svg'
import table from 'assets/icons/masa-gray.svg'

const NewPlanSideBar = (props: { model: ISideBarModel }) => {
  const { t } = useTranslation()
  const [state, setState] = useState({ homeOffice: [], tableReservation: [], otherTableReservation: [] })
  const group = (squads: { Employee: IEmployeeSummary; Event: ICalendarPlan }[]) => {
    let homeOffice: { Employee: IEmployeeSummary; Event: ICalendarPlan }[] = []
    let tableReservation: { Employee: IEmployeeSummary; Event: ICalendarPlan }[] = []
    let otherTableReservation: { Employee: IEmployeeSummary; Event: ICalendarPlan }[] = []
    squads.forEach((squad) => {
      if (squad.Event.planType === PlanTypes.HomeOffice) {
        homeOffice.push(squad)
      } else if (
        squad.Event.planType === PlanTypes.TableReservation ||
        squad.Event.planType === PlanTypes.TableFloorReservation
      ) {
        tableReservation.push(squad)
      } else if (
        squad.Event.planType === PlanTypes.OtherLocationTableReservation ||
        squad.Event.planType === PlanTypes.OtherLocationTableFloorReservation
      ) {
        otherTableReservation.push(squad)
      }
    })
    setNodeData(homeOffice, 'homeOffice')
    setNodeData(tableReservation, 'tableReservation')
    setNodeData(otherTableReservation, 'otherTableReservation')
  }

  useEffect(() => {
    // @ts-ignore
    let selectedEvents: { Employee: IEmployeeSummary; Event: ICalendarPlan }[] = [...props.model.event]
    group(selectedEvents)
  }, [])

  const setNodeData = (list: { Employee: IEmployeeSummary; Event: ICalendarPlan }[], state: string) => {
    let _tempData = list.map((item, index) => {
      return (
        <AccordionTab header={accordionTabHeader(item)} key={index}>
          {accordionTabBody(item)}
        </AccordionTab>
      )
    })

    setState((prevState) => ({ ...prevState, [state]: _tempData }))
  }

  const formatDate = (date: Date) => {
    if (date === null || date === undefined) return ''
    let res = moment(date)
    return res.format('DD.MM.YYYY')
  }

  const accordionTabHeader = (data: { Employee: IEmployeeSummary; Event: ICalendarPlan }) => {
    let border =
      data.Event.planType === PlanTypes.HomeOffice
        ? 'home-border'
        : data.Event.planType === PlanTypes.TableReservation || data.Event.planType === PlanTypes.TableFloorReservation
        ? 'office-border'
        : ' common-office-border'
    return (
      <React.Fragment>
        <div key={data.Employee.id} className="d-flex flex-row">
          <div className="p-2 d-flex align-items-center">
            <AsyncImage src={data.Employee._photoUrl} className={'of-photo of-calendar-photo ' + border} />
          </div>
          <div className="p-2 d-flex flex-column justify-content-center">
            <div className={'of-name mb-2'}>{data.Employee.fullName}</div>
            <div className={'of-title'}>{data.Employee.positionName}</div>
          </div>
        </div>
      </React.Fragment>
    )
  }

  const accordionTabBody = (data: { Employee: IEmployeeSummary; Event: ICalendarPlan }) => {
    return (
      <div>
        {data.Event && (
          <div className="p-2">
            <div className="d-flex justify-content-start mt-1">
              <img className="of-plan-icon me-3" src={location} alt="location" />
              <div>
                <div>
                  <span className={'info-sub-title'}>{t('most-used-words.location')}</span> :{' '}
                  {data.Event.planType !== 1 ? (
                    <span className={'info-sub-content'}>{data.Event.locationFirmName}</span>
                  ) : (
                    <span className={'info-sub-content'}>{data.Event.description}</span>
                  )}
                </div>
                <div>
                  {data.Event.planType !== 1 && (
                    <span className={'info-sub-content'}>
                      {data.Event.locationName} {data.Event.cityName} / {data.Event.countryName}
                    </span>
                  )}
                </div>
              </div>
            </div>

            {data.Event.planType !== 1 && (
              <div className="d-flex justify-content-start mt-1">
                <img className="of-plan-icon me-3" src={building} alt="building" />
                <div>
                  <div>
                    <span className={'info-sub-title'}>{t('most-used-words.block')}</span> :{' '}
                    <span className={'info-sub-content'}>{data.Event.blockName}</span>
                  </div>
                  <div>
                    <span className={'info-sub-title'}>{t('most-used-words.floor')}</span> :{' '}
                    <span className={'info-sub-content'}>{data.Event.floorName}</span>
                  </div>
                </div>
              </div>
            )}
            {data.Event.planType !== 1 && (
              <div className="d-flex justify-content-start mt-1">
                <img className="of-plan-icon me-3" src={table} alt="table" />
                <div>
                  <span className={'info-sub-title'}>{t('calendar.table-no')}</span> :{' '}
                  <span className={'info-sub-content'}>{data.Event.tableNum}</span>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    )
  }

  return (
    <div className={'of-squads-modal'}>
      <div className={'title'}>{t('profile.content.notification-settings.my-squads-notifications')}</div>
      <div className={'content'}>
        {t('squads-event.text1')} ‘’{formatDate(props.model.day.date)}’’ {t('squads-event.text2')} ‘’
        {state?.tableReservation.length + state?.otherTableReservation.length + state?.homeOffice.length}’’{' '}
        {t('squads-event.text3')}
      </div>

      {state?.tableReservation.length > 0 && (
        <>
          <div className={'sub-title mb-2'}>
            {' '}
            {t('calendar.work-from-office')} ({state?.tableReservation.length})
          </div>
          <Accordion multiple className={'mb-2'}>
            {state.tableReservation}
          </Accordion>
        </>
      )}
      {state?.otherTableReservation.length > 0 && (
        <>
          <div className={'sub-title mb-2'}>
            {t('calendar.work-from-shared-office')} ({state?.otherTableReservation.length})
          </div>
          <Accordion multiple className={'mb-2'}>
            {state.otherTableReservation}
          </Accordion>
        </>
      )}
      {state?.homeOffice.length > 0 && (
        <>
          <div className={'sub-title mb-2'}>
            {t('tabs.remote-work')} ({state?.homeOffice.length})
          </div>
          <Accordion multiple className={'mb-2'}>
            {state.homeOffice}
          </Accordion>
        </>
      )}
    </div>
  )
}
export default NewPlanSideBar
